import { getRgObjectsOfType as m, RG_TYPE as n, getFloorOffsetFromApartment as c } from "@project-rouge/rg-core";
const d = (r) => {
  let o = 0;
  const f = m(r, n.Building);
  for (const e of f) {
    const l = e.children.find((t) => t.type === n.Apartment), a = c(l), s = e.data.levels.filter((t) => !t.isRoof), i = Math.max(...s.map((t) => t.floorWorldBottom)) + a;
    o = Math.max(o, i);
  }
  return o;
};
export {
  d as getMaxFfl
};
//# sourceMappingURL=index33.js.map
